import moment from 'moment';

export const initWalkMe = (data, url) => {
  const walkMeData = {
    userId: data.userId,
    emailAddress: data.emailAddress,
    resourceCreationDaysElapsed: moment.utc().diff(data.userCreatedAt * 1000, 'day'),
    databaseCreationDaysElapsed: moment.utc().diff(data.organizationCreatedAt * 1000, 'day'),
    firstName: data.firstName,
    lastName: '',
    companyName: data.companyName,
    tenantId: data.tenantId,
    utcDate: data.utcDate,
    utcTime: data.utcTime,
    featureAccess: data.featureAccess,
    role: data.role,
    locale: 'en-US',
    applicationVersionNumber: '1.0.0',
    salesforceId: data.salesforceId,
    isKaseya365: data.isKaseya365,
    isAccountTrial: data.isAccountTrial
  };

  const walkme = document.createElement('script');
  walkme.type = 'text/javascript';
  walkme.async = true;
  walkme.src = url;
  document.head.appendChild(walkme);
  window._walkmeConfig = { smartLoad: true };
  window.walkMeData = walkMeData;
};
